import GlobalEmitter from '~/glxp/utils/emitter'

export function onLoadAnimationEnd(callback) {
  GlobalEmitter.once('loader_animation_end', callback)
}
